import axios from "axios";
import type { CurrentUser } from "@workspace/types";
import type { WorkspaceData } from "@workspace/types";

const API_URL = "https://api.dev.yolk.coach/_internal/app";

function makeServerClient(accessToken: string) {
  return axios.create({
    baseURL: process.env.NEXT_PUBLIC_YOLK_API_URL || API_URL,
    // The layouts await these calls before returning any HTML, so a hung
    // backend must not hang the whole page — bail out and let the client
    // fetch path take over.
    timeout: 3000,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}

export async function serverGetCurrentUser(
  accessToken: string,
): Promise<CurrentUser> {
  const client = makeServerClient(accessToken);
  return (await client.get<CurrentUser>("/users/me")).data;
}

export async function serverGetWorkspaces(
  accessToken: string,
): Promise<WorkspaceData[]> {
  const client = makeServerClient(accessToken);
  return (await client.get<{ items: WorkspaceData[] }>("/workspaces")).data
    .items;
}
